import type { ICampaignAnalyticMetricFunc } from '~/modules/campaign-analytics';
import type { IAnalyticMetric } from '~/types/metric';

import { EMPTY_METRIC_DATA, TOOLTIP_EMPTY_METRIC_DATA } from '~/modules/campaign';
import { useCampaignAnalyticMetricFunc } from '~/modules/campaign-analytics';
import { formatMetricByFormatter } from '~/modules/analytics';
import { useConvertMoneyByCurrency } from '~/modules/shopify';
import { GTooltip } from '~/presentation/ui';
import { Text } from '@shopify/polaris';
import { useMemo } from 'react';

export interface MetricRatePropertyProps {
  metric?: IAnalyticMetric;
  functionKey: keyof ICampaignAnalyticMetricFunc;
}

export const MetricProperty: React.FC<MetricRatePropertyProps> = ({ metric, functionKey }) => {
  const funcGetMetric = useCampaignAnalyticMetricFunc();
  const { getTextPrice } = useConvertMoneyByCurrency();

  const dataMetric = useMemo(
    () => funcGetMetric?.[functionKey]?.({ metric }),
    [funcGetMetric, functionKey, metric],
  );
  const value = useMemo(() => {
    const valueFormatted = formatMetricByFormatter({
      value: dataMetric.value || 0,
      formatter: dataMetric.formatter,
      getTextPrice,
    });

    return valueFormatted;
  }, [dataMetric.formatter, dataMetric.value, getTextPrice]);
  return (
    <GTooltip isEnabled={value === EMPTY_METRIC_DATA} content={TOOLTIP_EMPTY_METRIC_DATA}>
      <Text as="p" variant="bodySm" alignment="end">
        {metric ? value : EMPTY_METRIC_DATA}
      </Text>
    </GTooltip>
  );
};
